import { SPANISH_BANKS_LIST } from '../constants/spanishBanksList';

export const getBankDetailsByAccountNumber = ({ accountNumber }) => {
  if (accountNumber) {
    const formattedAccountNumber = accountNumber.replace(/\s/g, '');
    const accountSupervisorCode = formattedAccountNumber.substring(4, 8);
    const bankDetails = SPANISH_BANKS_LIST.find((bank) => bank.SUPERVISOR_CODE === accountSupervisorCode);
    return bankDetails;
  }
  return null;
};
